import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { SERVICE_END_POINT } from 'src/app/shared/services/api-constants/service-endpoints.constants';
import { QuoteDataCaptureService } from 'src/app/shared/services/api-services/quote-datacapture.service';
import { UtilService } from 'src/app/shared/services/api-services/util.service';
import { AppState } from 'src/app/store/state/app.state';
import * as UserDataConfig from '../../config/user-data.config';
import * as GuidanceAndAdviceActions from '../../../../store/actions/guidance-and-advice.actions';
import { Observable } from 'rxjs/Observable';
import * as StoreModel from 'src/app/model/ngrx';
import { DatePipe } from '@angular/common';
import { Subscription } from 'rxjs/Subscription';
import { AnalyticsService } from 'src/app/shared/services/api-services/analytics.service';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';
import * as loggedInDetailActions from '../../../../store/actions/loggedin-detail.action';
import { RefNo, YourPension } from 'src/app/model/ngrx';
import * as YourPensionActions from '../../../../store/actions/your-pension.actions';
import { AuthService } from 'src/app/shared';
@Component({
  selector: 'app-guidance-and-advice',
  templateUrl: './guidance-and-advice.component.html',
  styleUrls: ['./guidance-and-advice.component.scss']
})
export class GuidanceAndAdviceComponent implements OnInit {
  public contentData;
  public CMSData;
  public userInputDetail = UserDataConfig.ElementsConfig;
  public guidanceAdviceConfig1 = this.userInputDetail.guidanceAdviceConfig1;
  public guidanceAdviceConfig2 = this.userInputDetail.guidanceAdviceConfig2;
  public guidanceandAdviceForm: UntypedFormGroup;
  public isDisabledCTA: boolean = true;
  public isInfoBlock: boolean = false;
  public isFutureDate: boolean = false;
  public isFirstQuestion: boolean = true;
  public appmntDate = "";
  public isBookedDate: boolean = false;
  public isCaseBookMyOwn: boolean = false;
  public isShowYesInfo: boolean = true;
  guidanceAndAdviceDetail: StoreModel.GuidanceAndAdvice;
  guidanceAndAdviceDetailStore: Observable<StoreModel.GuidanceAndAdvice[]>;
  private subscripBeforeLogin: Subscription;
  private subscriptn: Subscription;
  private subscripLogout: Subscription;
  public isFirstBookMyOwn: boolean = true;
  referenceNumberStore: Observable<RefNo[]>;
  referenceNumber: RefNo;
  protected loginDetail: any;
  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private utilService: UtilService,
    private fb: UntypedFormBuilder,
    private quoteDatacaptureService: QuoteDataCaptureService,
    private store: Store<AppState>,
    private datePipe: DatePipe,
    private analyticsService:AnalyticsService, private authService: AuthService) {
      this.contentData = this.activatedRoute.snapshot.data.contentData.guidanceAndAdvice;
      this.referenceNumberStore = store.select(STORE_VAL.ref_no);
      this.referenceNumberStore.subscribe((val) => {
        if (val.length > 0) {
          this.referenceNumber = val[0];
        } else {
          this.referenceNumber = null;
        }
      });
      this.guidanceAndAdviceDetailStore = this.store.select(STORE_VAL.guidance_and_advice);
    }

    ngOnInit() {
    this.initalizeForm();
    this.userInputDetail.buttonConfig.label = "Next";
    const URL =  SERVICE_END_POINT.higherEnvironment.CMS_GuidanceAndAdvice;
    this.analyticsService.eventTrack({ referenceId: this.getRefNo()});
    this.utilService.getCMSData(URL)
    .subscribe(res => {
      if(res) {
        this.CMSData = res;
        this.bindCMSData();
        this.guidanceAndAdviceDetailStore.subscribe((val) => {
          if (val.length > 0) {
            // //console.log("store valueeeeeeee", val)
            this.guidanceAndAdviceDetail= val[0];
            this.setFormData();
          }
    });
      }
    });
    this.subscripBeforeLogin = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeLoginFunction.subscribe(() => {
      this.saveAfterLogin();
    });
    this.subscripLogout = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeLogoutFunction.subscribe(() => {
      this.saveAfterLogout();
    });
    this.store.select(STORE_VAL.loggedin_detail).subscribe(res => {
      if (res.length > 0) {
        this.loginDetail = res[0];
      }
    });
  }
  // Initalize form
  initalizeForm() {
    this.guidanceandAdviceForm = this.fb.group({
      bookPensionWiseAppointmentQuestion: [''],
      attendedPensionWiseAppointmentQuestion: ['']
    });
  }
  setFormData() {
    this.utilService.pwAppointmentdate$.subscribe(appntDate => {
      if(appntDate != "") {
        this.isShowYesInfo = false;
        this.appmntDate = appntDate;
        this.bookedAppointmentChange(appntDate)
      }
    });
    this.guidanceAndAdviceDetail.riskAndStaticQuestion.forEach(ele => {
      if(ele.questionCode === "bookPensionWiseAppointmentQuestion") {
        this.guidanceandAdviceForm.controls.bookPensionWiseAppointmentQuestion.setValue(ele.answer);
        if(ele.answer == "AB" &&  this.isFirstBookMyOwn ) { this.caseBookMyOwn() }
        else if(ele.answer != "") { this.firstQuestionChange(false);}
      }
      if(ele.questionCode === "attendedPensionWiseAppointmentQuestion") {
        this.guidanceandAdviceForm.controls.attendedPensionWiseAppointmentQuestion.setValue(ele.answer);
        if(ele.answer != "") { this.secondQuestionChange(false); }
      }
    });
  }

  // Preparing the payload for store
  createQuestionarray(param) {
    const questionArray = [];
    let formData = this.guidanceandAdviceForm.controls;
    if(param === "first") {
      questionArray.push({
        questionCode: this.contentData.bookPensionWiseAppointmentQuestion.questionCode,
        questionType: this.contentData.bookPensionWiseAppointmentQuestion.questionType,
        answer: formData.bookPensionWiseAppointmentQuestion.value
      });
      const detail = this.guidanceAdviceConfig1.options.find(q => q.code == formData.bookPensionWiseAppointmentQuestion.value)
      this.adobeAnalytics("Would you like us to book a pensionwise appointment", "Book a free pension appointment", detail.value);
    }
    else if(param == "second") {
      questionArray.push({
        questionCode: this.contentData.attendedPensionWiseAppointmentQuestion.questionCode,
        questionType: this.contentData.attendedPensionWiseAppointmentQuestion.questionType,
        answer: formData.attendedPensionWiseAppointmentQuestion.value
      });
      const pageId = "Your PensionWise appointment";
      const detail = this.guidanceAdviceConfig2.options.find(q => q.code == formData.attendedPensionWiseAppointmentQuestion.value)
      if(this.isCaseBookMyOwn) {
        this.adobeAnalytics("Confirm you have received guidance or chosen to opt out", pageId, detail.value);
      }
      else if(this.isFutureDate) {
        this.adobeAnalytics("Have you attended a different Pension Wise appointment", pageId, detail.value);
      }
      else {
        this.adobeAnalytics("Have you attended your Pension Wise appointment", pageId, detail.value);
      }
    }
    else {
      questionArray.push({
        questionCode: this.contentData.bookPensionWiseAppointmentQuestion.questionCode,
        questionType: this.contentData.bookPensionWiseAppointmentQuestion.questionType,
        answer: formData.bookPensionWiseAppointmentQuestion.value
      });
      questionArray.push({
        questionCode: this.contentData.attendedPensionWiseAppointmentQuestion.questionCode,
        questionType: this.contentData.attendedPensionWiseAppointmentQuestion.questionType,
        answer: formData.attendedPensionWiseAppointmentQuestion.value
      });
    }
    return questionArray;
  }
  // Capture event for Would you like us to book you a pension wise appointment?
  firstQuestionChange(triggerPayload) {
    switch (this.guidanceandAdviceForm.controls.bookPensionWiseAppointmentQuestion.value) {
      case "AA":
        this.isDisabledCTA = true;
        this.isInfoBlock = true;
        if(this.isShowYesInfo) {
          this.contentData.string_ByDefaultInfoBlock = this.innerHTMLData(this.CMSData.html_IfYesSelected , "inner-content-data");
        }
      break;
      case "AB":
        this.isFirstBookMyOwn = false;
        this.isDisabledCTA = true;
        this.isInfoBlock = true;
        this.contentData.string_ByDefaultInfoBlock = this.innerHTMLData(this.CMSData.string_IfNoIWillBookMyOwnAppointment , "inner-content-data");
      break;
      case "AC":
        this.isDisabledCTA = false;
        this.isInfoBlock = true;
        this.contentData.string_ByDefaultInfoBlock = this.innerHTMLData(this.CMSData.string_NoIHaveAlreadyReceivedPensionsGuidance , "inner-content-data");
        break;
      case "AD":
        this.isDisabledCTA = false;
        this.isInfoBlock = false;
      break;
      case "AE":
        this.isDisabledCTA = false;
        this.isInfoBlock = true;
        this.contentData.string_ByDefaultInfoBlock = this.innerHTMLData(this.CMSData.string_NoIWantToProceedWithoutGuidanceOrAdvice , "inner-content-data");
      break;
      default:
        this.isDisabledCTA = true;
        this.isInfoBlock = false;
        break;
    }
    if(triggerPayload) { this.sendData("first"); }
  }
  // Capture event for Have you attended your Pension Wise appointment?
  secondQuestionChange(triggerPayload) {
    this.isInfoBlock = false;
    switch (this.guidanceandAdviceForm.controls.attendedPensionWiseAppointmentQuestion.value) {
      case "AA":
        this.isDisabledCTA = false;
        this.isFirstQuestion = false;
      break;
      case "AD":
        this.isDisabledCTA = false;
        this.isFirstQuestion = false;
      break;
      case "AC":
        this.isDisabledCTA = true;
        this.isShowYesInfo = true;
        this.guidanceandAdviceForm.controls.bookPensionWiseAppointmentQuestion.setValue("");
        const contentAC = this.CMSData.string_RebookAFreePensionWiseAppointment.replace("<a", '<a target="_blank" class="inner-anchor"');
        this.contentData.string_noWithoutGuidance = this.innerHTMLData(contentAC , "content-top");
        this.guidanceAdviceConfig1.options = this.guidanceAdviceConfig1.options1;
        this.isFirstQuestion = true;
      break;
      case "AE":
        if(this.isFutureDate) {
          this.isInfoBlock = true;
          this.isFirstQuestion = false;
          this.contentData.string_ByDefaultInfoBlock = this.innerHTMLData(this.CMSData.string_NoIWantToProceedWithoutGuidanceOrAdvice , "inner-content-data");
          this.isDisabledCTA = false;
        } else {
          this.isDisabledCTA = true;
          this.isShowYesInfo = true;
          this.guidanceandAdviceForm.controls.bookPensionWiseAppointmentQuestion.setValue("");
          const contentAE = this.CMSData.string_RebookAFreePensionWiseAppointment.replace("<a", '<a target="_blank" class="inner-anchor"');
          this.contentData.string_noWithoutGuidance = this.innerHTMLData(contentAE , "content-top");
          this.guidanceAdviceConfig1.options = this.guidanceAdviceConfig1.options1;
          this.isFirstQuestion = true;
        }
      break;
      default:
        this.isDisabledCTA = true;
        this.isInfoBlock = false;
      break;
    }
    if(triggerPayload) { this.sendData("second"); }
  }
  // Disapatching data into store
  sendData(param) {
    let payload = this.createQuestionarray(param)
    this.store.dispatch(new GuidanceAndAdviceActions.RemoveGuidanceAndAdvice(0));
      this.store.dispatch(new GuidanceAndAdviceActions.AddGuidanceAndAdvice({
        riskAndStaticQuestion: payload,
      }));

    this.quoteDatacaptureService.postQuoteDataCapture(true).subscribe(res => {
      if (res && res.cameFromMicrosite) {
        let yourPensionObj: YourPension= {
          aegon: { fundValue: null, transferType: "CDF", productCode: [] },
          external: { fundValue: null, transferType: "Ext", productCode: [] },
          internal: { fundValue: null, transferType: "Int.", productCode: [] },
          manualSource: null,
          reAssure: { fundValue: null, transferType: "CDF", productCode: [] }, 
          sunLife: { fundValue: null, transferType: "CDF", productCode: [] },
          phoenixLife: { fundValue: null, transferType: "CDF", productCode: [] },
          pensionBee: { fundValue: null, transferType: "CDF", productCode: [] },
          aon: { fundValue: null, transferType: "CDF", productCode: [] },
         /* ddp1: { fundValue: null, transferType: "CDF", productCode: [] },
          ddp2: { fundValue: null, transferType: "CDF", productCode: [] },
          ddp3: { fundValue: null, transferType: "CDF", productCode: [] },
          ddp4: { fundValue: null, transferType: "CDF", productCode: [] },*/
          guarantees: null,
          penalties: null,
          totalSum: null,
          fundProvider: res.source ? res.source : null,
          riskAndStaticQuestion: null,
          cedingFund:  null,
          productCodes: null,
          benefitTypes: null,
          cameFromMicrosite: res.cameFromMicrosite,
          fundValidateInd: false,
        };
        this.store.dispatch(new YourPensionActions.RemoveYourPension(0));
        this.store.dispatch(new YourPensionActions.AddYourPension({ ...yourPensionObj }));
      }
    });
  }

  backToRegistration() {
    this.analyticsService.eventTrack({
      type: 'ButtonClick',
      name: 'Back',
      pageID: this.utilService.getScreenNameFromURL(this.router.url)
    });
    this.store.dispatch(new loggedInDetailActions.RemoveLoggedInDetail(0));
    this.router.navigate(['/home/registration']);
  }

  // Compare the date and return boolean for Future Date
  checkedFutureDate(bookedDate) {
    const year = bookedDate.substr(6, 4);
    const month = bookedDate.substr(3, 2) - 1;
    const day = bookedDate.substr(0, 2);
    let bookdate = new Date(year, month, day).setHours(0, 0, 0, 0);
    let today = new Date().setHours(0, 0, 0, 0);
    if(bookdate >= today) {
      return true;
    }
    else { return false;}
  }
  //Logic based on pre book appointment
  bookedAppointmentChange(bookedDate) {
    this.isBookedDate = true;
    this.isFutureDate = this.checkedFutureDate(bookedDate)
    this.isFirstQuestion = false;
    this.contentData.header = this.CMSData.string_YourPensionWiseAppointmentTitle;
    this.contentData.string_ByDefaultContent = ""
    this.guidanceAdviceConfig2.label = this.CMSData.string_HaveYouAttendedAppointmentQuestion;
    if(this.isFutureDate) {
      const content = this.CMSData.string_YourPensionWiseAppointmentAlternativeWording.replace("DD / MM / YYYY", this.appmntDate)
      this.contentData.string_ByDefaultContent = this.innerHTMLData( content, "content-top");
      this.guidanceAdviceConfig2.label = this.CMSData.string_HaveYouAttendedAppointmentQuestion2;
      this.guidanceAdviceConfig2.options = this.guidanceAdviceConfig2.options2;
    }
  }

  // First question: I will book my appointment
  caseBookMyOwn() {
    this.isFirstQuestion = false;
    this.isCaseBookMyOwn = true;
    this.contentData.header = this.CMSData.string_YourPensionWiseAppointmentTitle;
    this.guidanceAdviceConfig2.label = this.CMSData.string_HaveYouAttendedAppointmentQuestion;
    this.contentData.string_ByDefaultContent = this.innerHTMLData( this.CMSData.string_PensionWiseAppointmentBookedOwnWording, "content-top");
    this.guidanceAdviceConfig2.options = this.guidanceAdviceConfig2.options;
    this.guidanceAdviceConfig2.options[1].value = "No – I did not book or attend my appointment"
  }

  // Go to next Page: Before-you-Start
  gotoNextPage= () => {
    if(!this.isDisabledCTA) {
      const answer = this.guidanceandAdviceForm.get('bookPensionWiseAppointmentQuestion').value;
      if (answer === 'AC' || answer === 'AD' || answer === 'AE') {
        this.sendData("first");
      } else {
        this.sendData("default");
      }
      const analyticAnswer = this.guidanceAdviceConfig1.options.find(q => q.code == this.guidanceandAdviceForm.controls.bookPensionWiseAppointmentQuestion.value)
      this.analyticsService.customerTrack({"pensionwiseStatus": analyticAnswer.value})
      this.router.navigate(['/home/before-you-start']); }
  }
  ngOnDestroy() {
    if (this.subscriptn) {
      this.subscriptn.unsubscribe();
    }
    if (this.subscripBeforeLogin) {
      this.subscripBeforeLogin.unsubscribe();
    }
    if (this.subscripLogout) {
      this.subscripLogout.unsubscribe();
    }
  }
  saveAfterLogin() {
    this.sendData("default");
    this.subscriptn = this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe(res => {
      this.utilService.afterSaveSuccesfully();
    });
  }
  saveAfterLogout() {
    this.sendData("default");
    this.subscriptn = this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe(res => {
      this.authService.logout();
    });
  }

  bindCMSData() {
      const content = this.CMSData.string_PensionWisefirstparawording.replace("<a", '<a target="_blank" class="inner-anchor"');
      this.contentData.string_ByDefaultContent = this.innerHTMLData(content , "content-top");
      this.guidanceAdviceConfig1.label = this.CMSData.string_WouldYouLikeUsToBookQuestion;
      this.contentData.header = this.CMSData.string_GuidanceAndAdviceTitle;
  }
  innerHTMLData(content, customClass) {
    let final_string;
    const p = "<p class=" + customClass + " >";
    if(content.includes("<p>")) {
      final_string =  content.replaceAll("<p>", p);
    }
    else {
      final_string = p + content + "</p>"
    }
    return final_string;
  }

  getRefNo() {
    return  this.referenceNumber ? this.referenceNumber : null;
  }
  // Sending event for adobe analytics
  adobeAnalytics(name = '', pageID = '', details = '') {
    this.analyticsService.eventTrack({type: 'Dropdown', name: name, pageID: pageID, details: details});
  }
}